import { render, staticRenderFns } from "./StopLicense.vue?vue&type=template&id=be561f0c"
import script from "./StopLicense.vue?vue&type=script&lang=js"
export * from "./StopLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports